import React from 'react';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import styled, {css} from 'styled-components';
import Button from '../Button';
import {
    breakpoints,
    Flex,
    mobileMediaQuery,
    notWebMediaQuery,
    tabletMediaQuery,
} from '../../styles';

import ErrorHero from '../../assets/error-hero.png';
import GlobImage from '../../assets/glob.png';
import StarBackground from '../../assets/star_background_tablet.png';
import {debugCNitoUrl, useBrand, useIsCartoonito} from '../../helpers';
import {ReactComponent as RefreshIcon} from '../../assets/ic_refresh.svg';

export const ErrorContainer = () => {
    const history = useHistory();
    const {t} = useTranslation();
    const isCartoonito = useIsCartoonito();
    const brand = useBrand();

    const handleRetry = () => {
        history.replace(`/${debugCNitoUrl()}`);
    };

    if (brand === 'dkids') {
        return (
            <Container brand={brand}>
                <Stars />
                <Title>{t(`error.cnito.title`)}</Title>
                <Subtitle>{t(`error.cnito.subtitle`)}</Subtitle>
                <Button
                    width="280px"
                    margin="0 0 16px 0"
                    background="#3A9D2E"
                    value={t('error.cta')}
                    onClick={handleRetry}
                    dkids
                />
                <img
                    src={require('../../assets/dkids/ill_error_dkids.png')}
                    alt=""
                />
            </Container>
        );
    }

    return (
        <Container cnito={isCartoonito}>
            <h1>{t(`error${isCartoonito ? '.cnito' : ''}.title`)}</h1>
            {!isCartoonito && (
                <p>{t(`error${isCartoonito ? '.cnito' : ''}.subtitle`)}</p>
            )}
            <img
                width="42%"
                height="auto"
                src={isCartoonito ? GlobImage : ErrorHero}
                alt=""
            />
            {isCartoonito && (
                <p>{t(`error${isCartoonito ? '.cnito' : ''}.subtitle`)}</p>
            )}
            <Button
                cnito={isCartoonito}
                light={!isCartoonito}
                onClick={handleRetry}
            >
                {t('error.cta')}
                <RefreshIcon marginLeft="10px" />
            </Button>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    justify-content: center;
    align-items: center;
    margin: auto;

    h1 {
        margin: 0 0 12px 0;
        text-transform: initial;
        font-size: 45px;
        font-weight: bold;
        line-height: 56px;
        text-align: center;
    }

    p {
        margin: 0 0 19.5px 0;
        font-size: 18px;
        line-height: 30px;
        text-align: center;
    }

    img {
        margin-bottom: 25.5px;
        object-fit: contain;
        max-height: 257px;
        max-width: 607px;
    }

    svg {
        margin-left: 10px;
    }

    ${notWebMediaQuery} {
        padding-top: 78px;
    }

    ${props =>
        props.cnito &&
        css`
            background-color: #32bf5e;
            padding-top: 82px;
            padding-bottom: 72px;
            flex: 1;
            color: #000;
            background-image: url(${StarBackground});
            background-size: contain;

            ${notWebMediaQuery} {
                padding-top: 142px;
            }

            h1 {
                font-family: 'Rodger';
                font-weight: 900;
                font-size: 24px;
                line-height: 31px;
                margin: 0;
                text-transform: uppercase;
            }

            p {
                font-size: 18px;
                line-height: 24px;
                font-family: 'AvenirNextRoundedStd';
                font-weight: 600;
                margin: 0 0 32px 0;

                ${mobileMediaQuery} {
                    font-size: 16px;
                    margin: 0 10px 24px 10px;
                }

                ${tabletMediaQuery} {
                    max-width: 300px;
                }
            }

            img {
                margin: 40px 0;
                max-height: 235px;
                max-width: 240px;
            }

            @media screen and (max-width: ${breakpoints.sm}px),
                screen and (max-height: ${breakpoints.sm}px) {
                padding-top: 142px;

                justify-content: center;

                ${Flex} {
                    max-width: 265px;
                }
            }
        `}
    ${props =>
        props.brand === 'dkids' &&
        css`
            position: relative;
            flex: 1;
            padding-bottom: 140px;
            min-height: 600px;
            background: url(${require('../../assets/dkids/livestream_bg.png')}),
                linear-gradient(
                    175.58deg,
                    #1d21b1 3.45%,
                    #1d21b1 75.8%,
                    #2937bd 96.31%
                );
            background-size: cover;
            img {
                position: absolute;
                bottom: 0;
                margin: 40px 0;
                max-height: unset;
                max-width: 100%;
                pointer-events: none;
            }
        `}
`;

const Title = styled.div`
    font-family: 'DKIDS';
    font-size: 26px;
    line-height: 36px;
    margin-bottom: 16px;
    text-align: center;
    padding: 0 16px;
`;

const Subtitle = styled.div`
    font-family: 'Mont';
    font-size: 24px;
    font-weight: 400;
    line-height: 28px;
    max-width: 440px;
    text-align: center;
    margin-bottom: 32px;
    padding: 0 16px;
`;

const Stars = styled.img.attrs({
    src: require('../../assets/dkids/stars_bg.png'),
})`
    position: absolute;
    margin: 0 80px;
    min-width: 1000px;
`;
